/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterSelectionsDTO } from './filterSelectionsDTO';


export interface UpdateMIMFiltersRequestDTO { 
    clientId: number;
    brandId: number;
    conversionType: string;
    viewBy: UpdateMIMFiltersRequestDTO.ViewByEnum;
    relativeDay?: string;
    startDate?: string;
    endDate?: string;
    selections?: FilterSelectionsDTO;
}
export namespace UpdateMIMFiltersRequestDTO {
    export type ViewByEnum = 'ROAS' | 'CPO';
    export const ViewByEnum = {
        Roas: 'ROAS' as ViewByEnum,
        Cpo: 'CPO' as ViewByEnum
    };
}


